import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { isDevServer } from 'Utils'
import { GOOGLE_CLIENT_ID_UNIVERSAL } from 'Config/config'
import { GOOGLE_SCRIPT_PATH } from 'Defaults/googleScopes'
import { _GoogleIcon, _GoogleBtn, _GSIButtonContainer, _ErrorMsg } from './styles'
import useGoogleSSO from '../../hooks/useGoogleSSO'

const GoogleSSO = ({ userGoogleLogin, googleAnalyticsEvent, closeModal, loginPage, text = 'Sign In' }) => {
  const { loadScript, generateRandomNonce } = useGoogleSSO()
  const [googleClientError, setGoogleClientError] = useState('')
  const randomNonce = generateRandomNonce()
  const googleLoginCallback = async response => {
    userGoogleLogin({ crediential: response?.credential, loginPage, platform: 'web' })
    closeModal()
  }
  let fakeGoogleClick = {}
  const googleErrorCallback = (err) => {
    if(err.type === 'popup_failed_to_open' || err.type === 'popup_closed') {
      throw new Error(
        'Oops! It seems like the popup blocker is enabled in your browser. Please disable it and refresh the page. ' +
        'If you need further assistance, please reach out to our Support.',
      )
    }
  }
  useEffect(() => {
    loadScript(GOOGLE_SCRIPT_PATH)
      .then(() => {
        window?.google?.accounts?.id?.initialize({
          client_id: GOOGLE_CLIENT_ID_UNIVERSAL,
          callback: googleLoginCallback,
          nonce: randomNonce,
          error_callback: googleErrorCallback,
        })
        // this is to use our own custom google sign in btn instead of the official one
        const loginBtn = document.getElementById('googleSignInButton')
        loginBtn.style.display = 'none'
        window?.google?.accounts?.id?.renderButton(loginBtn, {
          type: 'icon',
          width: '200',
        })
        const googleLoginWrapperButton = loginBtn?.querySelector(
          'div[role=button]',
        )
        fakeGoogleClick = {
          click: () => {
            googleLoginWrapperButton?.click()
            googleAnalyticsEvent({
              category: 'GoogleSSO',
              action: '[SignIn Btn Click]',
            })
          },
        }
      })
      .catch(er =>
        setGoogleClientError(`Error in initializing google client ${er}`),
      )
  }, [])

  return (
    <_GSIButtonContainer aria-describedby="Google Sign In Button">
      <_GoogleBtn
        onClick={() => fakeGoogleClick?.click()}
        tabIndex={0}
        onKeyDown={(e) => {
          if(e.key === 'Enter') {
            fakeGoogleClick?.click()
          }
        }}
      >
        <div id={'googleSignInButton'} />
        <_GoogleIcon name="#icon-sso" width={20} height={20} />
        <p>{text} with Google</p>
      </_GoogleBtn>
      {isDevServer() && googleClientError && <_ErrorMsg>{googleClientError}</_ErrorMsg>}
    </_GSIButtonContainer>
  )
}

GoogleSSO.propTypes = {
  userGoogleLogin: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
  closeModal: PropTypes.func,
  loginPage: PropTypes.bool,
  text: PropTypes.string,
}
export default GoogleSSO
